import { translations } from '@/lib/translations'
import type { LanguageCode } from '@/config/languages'

/**
 * Get a translation outside of React components
 * Reads language from localStorage (same key as LanguageProvider uses)
 */
export function getTranslation(key: string): string {
  const storageKey = 'menu-ui-language'
  const language = (localStorage.getItem(storageKey) as LanguageCode) || 'en'
  return translations[language]?.[key] ?? translations.en?.[key] ?? key
}

